import { render, staticRenderFns } from "./solicitud-arbitraje.vue?vue&type=template&id=6df0abd6&lang=html&"
import script from "./solicitud-arbitraje.vue?vue&type=script&lang=js&"
export * from "./solicitud-arbitraje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports